import ConnectionPowerMarkdownId from "../assets/documentation/id/inputform/ConnectionPower.js";
import ConnectionPowerMarkdownEn from "../assets/documentation/en/inputform/ConnectionPower.js";
import MonthlyBillEn from "../assets/documentation/en/inputform/MonthlyBill.js";
import MonthlyBillId from "../assets/documentation/id/inputform/MonthlyBill.js";
import NumberOfPanelsEn from "../assets/documentation/en/results/NumberOfPanels.js";
import NumberOfPanelsId from "../assets/documentation/id/results/NumberOfPanels.js";
import NumberOfPanelsConnectionSizeEn from "../assets/documentation/en/results/NumberOfPanelsConnectionSize.js";
import NumberOfPanelsConnectionSizeId from "../assets/documentation/id/results/NumberOfPanelsConnectionSize.js";
import NumberOfPanelsConsumptionEn from "../assets/documentation/en/results/NumberOfPanelsConsumption.js";
import NumberOfPanelsConsumptionId from "../assets/documentation/id/results/NumberOfPanelsConsumption.js";
import NumberOfPanelsMinimumPaymentEn from "../assets/documentation/en/results/NumberOfPanelsMinimumPayment.js";
import NumberOfPanelsMinimumPaymentId from "../assets/documentation/id/results/NumberOfPanelsMinimumPayment.js";
import AreaRequiredEn from "../assets/documentation/en/results/AreaRequired.js";
import AreaRequiredId from "../assets/documentation/id/results/AreaRequired.js";
import MinimalPaymentEn from "../assets/documentation/en/results/MinimalPayment.js";
import MinimalPaymentId from "../assets/documentation/id/results/MinimalPayment.js";
import LocationEn from "../assets/documentation/en/inputform/Location.js";
import LocationId from "../assets/documentation/id/inputform/Location.js";
import RoiExplanationEn from "../assets/documentation/en/results/RoiExplanation.js";
import RoiExplanationId from "../assets/documentation/id/results/RoiExplanation.js";
import PriorityEn from "../assets/documentation/en/inputform/Priority.js";
import PriorityId from "../assets/documentation/id/inputform/Priority.js";
import PlnSettingsEn from "../assets/documentation/en/expert/PLNSettings.js";
import PlnSettingsId from "../assets/documentation/id/expert/PLNSettings.js";
import AppInfoEn from "../assets/documentation/en/app/AppInfo.js";
import AppInfoId from "../assets/documentation/id/app/AppInfo.js";
import {LimitingFactor} from "./CalculationService.js";
import * as Analytics from "./Analytics.js";
import {Category} from "./Analytics.js";
export var Documentation;
(function(Documentation2) {
  Documentation2[Documentation2["ConnectionPower"] = 0] = "ConnectionPower";
  Documentation2[Documentation2["MonthlyBill"] = 1] = "MonthlyBill";
  Documentation2[Documentation2["Location"] = 2] = "Location";
  Documentation2[Documentation2["NumberOfPanels"] = 3] = "NumberOfPanels";
  Documentation2[Documentation2["NumberOfPanelsConnectionSize"] = 4] = "NumberOfPanelsConnectionSize";
  Documentation2[Documentation2["NumberOfPanelsConsumption"] = 5] = "NumberOfPanelsConsumption";
  Documentation2[Documentation2["NumberOfPanelsMinimumPayment"] = 6] = "NumberOfPanelsMinimumPayment";
  Documentation2[Documentation2["AreaRequired"] = 7] = "AreaRequired";
  Documentation2[Documentation2["MinimalPayment"] = 8] = "MinimalPayment";
  Documentation2[Documentation2["RoiExplanation"] = 9] = "RoiExplanation";
  Documentation2[Documentation2["Priority"] = 10] = "Priority";
  Documentation2[Documentation2["PlnSettings"] = 11] = "PlnSettings";
  Documentation2[Documentation2["AppInfo"] = 12] = "AppInfo";
})(Documentation || (Documentation = {}));
export var Locale;
(function(Locale2) {
  Locale2["Indonesian"] = "id";
  Locale2["English"] = "en";
})(Locale || (Locale = {}));
function getIndonesian(doc) {
  switch (doc) {
    case 0:
      return ConnectionPowerMarkdownId.body;
    case 1:
      return MonthlyBillId.body;
    case 3:
      return NumberOfPanelsId.body;
    case 7:
      return AreaRequiredId.body;
    case 8:
      return MinimalPaymentId.body;
    case 4:
      return NumberOfPanelsConnectionSizeId.body;
    case 5:
      return NumberOfPanelsConsumptionId.body;
    case 6:
      return NumberOfPanelsMinimumPaymentId.body;
    case 2:
      return LocationId.body;
    case 9:
      return RoiExplanationId.body;
    case 10:
      return PriorityId.body;
    case 11:
      return PlnSettingsId.body;
    case 12:
      return AppInfoId.body;
  }
}
function getEnglish(doc) {
  switch (doc) {
    case 0:
      return ConnectionPowerMarkdownEn.body;
    case 1:
      return MonthlyBillEn.body;
    case 3:
      return NumberOfPanelsEn.body;
    case 7:
      return AreaRequiredEn.body;
    case 8:
      return MinimalPaymentEn.body;
    case 4:
      return NumberOfPanelsConnectionSizeEn.body;
    case 5:
      return NumberOfPanelsConsumptionEn.body;
    case 6:
      return NumberOfPanelsMinimumPaymentEn.body;
    case 2:
      return LocationEn.body;
    case 9:
      return RoiExplanationEn.body;
    case 10:
      return PriorityEn.body;
    case 11:
      return PlnSettingsEn.body;
    case 12:
      return AppInfoEn.body;
  }
}
export function documentation(locale, doc) {
  if (doc) {
    Analytics.event(Category.Documentation, Documentation[doc], locale);
  }
  switch (locale) {
    case Locale.Indonesian:
      return getIndonesian(doc);
    case Locale.English:
      return getEnglish(doc);
  }
}
export function toExplanation(limitingFactor) {
  switch (limitingFactor) {
    case LimitingFactor.ConnectionSize:
      return 4;
    case LimitingFactor.Consumption:
      return 5;
    case LimitingFactor.MinimumPayment:
      return 6;
  }
}
